import { render } from "./SpacesOutcoming.vue?vue&type=template&id=00a01a12&scoped=true&ts=true"
import script from "./SpacesOutcoming.vue?vue&type=script&lang=ts"
export * from "./SpacesOutcoming.vue?vue&type=script&lang=ts"

import "./SpacesOutcoming.vue?vue&type=style&index=0&id=00a01a12&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a01a12"]])

export default __exports__